export enum StudyLocation {
  ZUERICH = 'zuerich',
  STGALLEN = 'stgallen',
}
